import { createApp } from "vue";
import App from "./App.vue";
import vue3GoogleLogin from 'vue3-google-login';
import router from "@/router/index";
import i18n from "./i18n";
import axios from "axios";
import store from "@/store/index";
import titleManagement from "@/router/titleManagement";

import "@/assets/css/table.css";
import "@/assets/css/all.min.css";
import "@/assets/css/freamwork.css";
import "@/assets/css/master.css";
import FontAwesomeIcon from "./fontawesome/fontawesome";

const gAuthOption = {
  clientId: '1068183075757-609i9ejdq3ja5pa8aji7k1kusn967r45.apps.googleusercontent.com',
};
const app = createApp(App);
app.use(vue3GoogleLogin, gAuthOption);
app.component("font-awesome-icon", FontAwesomeIcon);
app.use(router);
app.use(i18n);
app.use(store);
titleManagement(router, i18n);
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL;

app.mount("#app");
